/**
 *
 * @description ひらがなをカタカナに変換する
 *
 */
const hiraganaToKatakana = (str: string) => {
	return str.replace(/[\u3041-\u3096]/g, (match) => {
		const chr = match.charCodeAt(0) + 0x60;
		return String.fromCharCode(chr);
	});
};

/**
 *
 * @description カタカナをひらがなに変換する
 *
 */
const katakanaToHiragana = (str: string) => {
	return str.replace(/[\u30A1-\u30F6]/g, (match) => {
		const chr = match.charCodeAt(0) - 0x60;
		return String.fromCharCode(chr);
	});
};

/**
 *
 * @description ひらがなとカタカナに対応する正規表現
 *
 * @param words {Array<string>} - 検索文字列
 * @returns {Array<RegExp>} - 正規表現の配列
 */
export const japaneseWordExpressions = (word: string): RegExp => {
	// 特殊文字のエスケープ
	const escapedWord = word.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
	const katakana = hiraganaToKatakana(escapedWord);
	const hiragana = katakanaToHiragana(escapedWord); // 既存の定義では、katakana を受け入れているが escapedWord で対応できるはず
	return new RegExp(`(${hiragana}|${katakana})`, "gi");
};
